import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Sparkles } from 'lucide-react';

interface SponsoredBadgeProps {
  className?: string;
  size?: 'sm' | 'md';
}

const sizeClasses = {
  sm: 'text-[10px] py-0 px-1.5 gap-0.5',
  md: 'text-xs py-0.5 px-2 gap-1',
};

const iconSizes = {
  sm: 'size-3',
  md: 'size-3.5',
};

export function SponsoredBadge({ className, size = 'md' }: SponsoredBadgeProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            'inline-flex items-center shrink-0 rounded-full font-medium',
            'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
            sizeClasses[size],
            className,
          )}
        >
          <Sparkles className={iconSizes[size]} />
          <span>Sponsored</span>
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        This is a promoted merchant listing
      </TooltipContent>
    </Tooltip>
  );
}
